export default __webpack_public_path__ + "static/media/avatar_2.2c362631.png";